import { useEffect, useState } from "react";
import "../../App.css";
import { API } from "../api";
import UperFooter from "./UperFooter";

const Footer = () => {
  const [footerData, setFooterData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch footer data from API
  const fetchFooterData = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${API}/api/footer`, {
        method: "GET",
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch footer data");
      }

      const data = await response.json();

      if (data.isSuccess && data.payload) {
        setFooterData(data.payload);
      } else {
        throw new Error("Invalid data format");
      }
    } catch (error) {
      console.error("Error fetching footer data:", error);
      setError(error.message);
      // Fallback to default data
      setFooterData({
        socialLinks: [
          { icon: "bi-facebook", link: "https://www.facebook.com" },
          { icon: "bi-twitter-x", link: "https://twitter.com" },
          { icon: "bi-linkedin", link: "https://linkedin.com" },
          { icon: "bi-instagram", link: "https://instagram.com" },
        ],
        description: "Our expert advisors offer strategic investment planning, risk management.",
        explore: [
          { label: "About Us", link: "/about-us" },
          { label: "Our Offerings", link: "/offerings" },
          { label: "Knowledge Center", link: "/knowledge-center" },
          { label: "Contact Us", link: "/contact" },
        ],
        contact: {
          titleSmall: "Have any query in your mind?",
          titleMain: "Let's Talk",
          buttonText: "Let's have a call",
        },
        uperFooter: {
          title: "Subscribe for regular Updates from",
          highlight: "Ladderup",
          inputPlaceholder: "Enter Email Address",
          buttonText: "Subscribe",
        },
        isinNo: "INE519D01015",
        stockCode: 530577
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFooterData();
  }, []);

  // Helper function to get media URL
  const getMediaUrl = (mediaObject) => {
    if (!mediaObject) return require("../../Images/footerLogo.png");

    if (mediaObject.path) {
      if (mediaObject.path.startsWith("http")) {
        return mediaObject.path;
      } else {
        return `${API}${mediaObject.path}`;
      }
    }

    if (mediaObject.id) {
      return `${API}/api/media/${mediaObject.id}`;
    }

    return require("../../Images/footerLogo.png");
  };

  if (loading) {
    return (
      <div style={{ background: "#28282b", color: "white", minHeight: "200px" }}>
        <div className="d-flex justify-content-center align-items-center" style={{ height: "200px" }}>
          <div className="spinner-border text-light" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
    );
  }

  if (error && !footerData) {
    return (
      <div style={{ background: "#28282b", color: "white" }}>
        <div className="alert alert-warning m-3" role="alert">
          Error loading footer: {error}
        </div>
      </div>
    );
  }

  return (
    <>
      <UperFooter data={footerData?.uperFooter} />
      <div style={{ background: "#28282b", color: "white" }}>
        <br />
        <div className="col-11 m-auto row mt-4 gap-md-0 gap-4 my-4">
          {/* Logo & Social */}
          <div className="col-lg-3 col-md-6 text-start">
            <img
              src={getMediaUrl(footerData?.image)}
              style={{ height: "60px" }}
              alt="Logo"
              loading="lazy"
              onError={(e) => {
                e.target.src = require("../../Images/footerLogo.png");
              }}
            />
            <p className="mt-2">{footerData?.description}</p>
            <div className="d-flex gap-3 my-2 fw-bold fs-3">
              {footerData?.socialLinks?.map((social, i) => (
                <p key={i}>
                  <a href={social.link} target="_blank" rel="noopener noreferrer">
                    <i className={`bi ${social.icon}`}></i>
                  </a>
                </p>
              ))}
            </div>
          </div>

          {/* Explore & SBI Details */}
          <div className="col-lg-4 col-md-6 row">
            <div className="col-6 text-start">
              <p className="fw-bold fs-5">Explore</p>
              {footerData?.explore?.map((item, i) => (
                <p key={i} style={{ cursor: "pointer" }}>
                  <a
                    href={item.link}
                    style={{ color: "white", textDecoration: "none" }}
                    onClick={(e) => {
                      e.preventDefault();
                      // You can add navigation logic here if using React Router
                      // navigate(item.link);
                    }}
                  >
                    {item.label}
                  </a>
                </p>
              ))}
            </div>
            <div className="col-6 text-start">
              <p className="fw-bold fs-5">SBI Details</p>
              <p className="mt-2">
                Stock code : <span className="fw-bold">{footerData?.stockCode}</span>
              </p>
              <p>
                ISIN number : <span className="fw-bold">{footerData?.isinNo}</span>
              </p>
            </div>
          </div>

          {/* Contact */}
          <div className="col-lg-5 col-md-6 text-start">
            <p>{footerData?.contact?.titleSmall}</p>
            <p className="display-2 fw-bold">{footerData?.contact?.titleMain}</p>
            <button className="buttonEffect text-white">
              {footerData?.contact?.buttonText}
            </button>
          </div>
        </div>
        <br />
      </div>
    </>
  );
};

export default Footer;